import type { RoomDetailsDto } from '@hcr/api/optimizely'
import { UNICODE } from '@hcr/ui'

type CreateRoomNameStringOptions = Pick<RoomDetailsDto, 'accommodationName' | 'size'>

export const createRoomNameString = ({ accommodationName, size }: CreateRoomNameStringOptions): string =>
  `${accommodationName}, ${size}m${UNICODE.superscriptTwo}`
